import { ChangeEvent, useEffect, useState } from 'react';
import { IAuftrag } from '../../types/Types';
import { useWiedervorlageMutation } from '../../api/AuftragAPI';
import { formatToEuroDate, formatToStringISODate } from '../../util/DateUtils';

interface ComponentProps {
  refresh?: () => void;
  uid_auftrag: string;
  statusChanged: () => void;
}

/**
 * @author noone
 */
const AuftragWiedervorlageComponent: React.FC<ComponentProps> = (props) => {

  const [setWiedervorlageAPI] = useWiedervorlageMutation();

  const [wiedervorlageTage, setWiedervorlageTage] = useState<number>(0);
  const [wiedervorlageDatum, setWiedervorlageDatum] = useState<Date>(new Date(new Date().setDate((new Date().getDate() + 1))));

  const submitWiedervorlage = async () => {

    var valueDate = new Date();

    if (wiedervorlageTage !== 0) {
      var datumInXTagen: Date = new Date();
      datumInXTagen.setDate(new Date().getDate() + wiedervorlageTage);
      valueDate = datumInXTagen;
    } else {
      valueDate = wiedervorlageDatum;
    }

    await setWiedervorlageAPI({ uid: props.uid_auftrag, datum: formatToStringISODate(valueDate) })
      .then(() => props.statusChanged())
      .catch((e) => alert("" + e));
  }

  return (
    <>
      <form onSubmit={(e) => { e.preventDefault(); submitWiedervorlage(); }}>

        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr" }}>
          <div className="input-group-text" id="basic-addon1">WVL:</div>
          
          <div>
            <input type="date" className="form-control" min={formatToStringISODate(new Date())} value={formatToStringISODate(wiedervorlageDatum)} onChange={(e) => setWiedervorlageDatum(new Date(e.target.value))} />
          </div>
          <div>
            <input type="submit" className='btn btn-warning' value="Wiedervorlage setzen" />
          </div>
        </div>
      </form>
    </>
  );

}

export default AuftragWiedervorlageComponent;